import {Action, ActionReducerMap, createFeatureSelector, createSelector} from '@ngrx/store';

import * as actionsUi from './dokumente.actions.ui';
import {TOGGEL_DOKUMENTE_GROUP_ACTION, ToggleDokumenteGroupAction} from './dokumente.actions.ui';
import { APP_RESET_ACTION } from '@orga-app/appstart/actions';
import {Dokument} from '../../../../clients/veranstaltungen';
import {GET_VERANSTALTUNG_DOKUMENTE, GET_VERANSTALTUNG_DOKUMENTE_ERFOLGREICH, GET_VERANSTALTUNG_DOKUMENTE_FEHLER, GetVeranstaltungDokumenteErfolgreichAction, GetVeranstaltungDokumenteFehlerAction} from '../../../../client-ngrx/veranstaltungen';


export interface ModuleState {
    page: PageState;
}

export const reducers: ActionReducerMap<ModuleState> = {
    page: pageReducer
};

export interface PageState {
    dokumente: Array<Dokument>;
    uiZeigeVeranstaltungDokumenteLaden: boolean;
    uiZeigeVeranstaltungDokumenteLadefehler: boolean;

    anzahlSpieltagDokumente: number;
    anzahlAllgemeineDokumente: number;

    filterString: string;
    activeDokumenteGroups: Array<string>;
}

export const initialPageState: PageState = {
    dokumente: [],
    uiZeigeVeranstaltungDokumenteLaden: false,
    uiZeigeVeranstaltungDokumenteLadefehler: false,
    anzahlSpieltagDokumente: 0,
    anzahlAllgemeineDokumente: 0,
    filterString: '',
    activeDokumenteGroups: []
};

export function pageReducer(state = initialPageState, action: Action): PageState {
    switch (action.type) {
        // Page State Reset
        case APP_RESET_ACTION: {
            return Object.assign({}, state, <PageState> initialPageState);
        }

        // Page State Reset
        case actionsUi.PAGE_STATE_RESET: {
            const a = <actionsUi.PageStateResetAction> action;

            return Object.assign({}, state, <PageState> initialPageState);
        }

        // Dokumente
        case GET_VERANSTALTUNG_DOKUMENTE: {
            return Object.assign({}, state, <PageState> {
                uiZeigeVeranstaltungDokumenteLaden: true
            });
        }

        case GET_VERANSTALTUNG_DOKUMENTE_ERFOLGREICH: {
            const a = <GetVeranstaltungDokumenteErfolgreichAction> action;

            const anzahlSpieltagDokumente = a.payload.filter(x => !x.ist_allgemeines_dokument);
            const anzahlAllgemeineDokumente = a.payload.filter(x => x.ist_allgemeines_dokument);

            return Object.assign({}, state, <PageState> {
                dokumente: a.payload,
                uiZeigeVeranstaltungDokumenteLaden: false,
                uiZeigeVeranstaltungDokumenteLadefehler: false,
                anzahlSpieltagDokumente: anzahlSpieltagDokumente.length,
                anzahlAllgemeineDokumente: anzahlAllgemeineDokumente.length
            });
        }

        case GET_VERANSTALTUNG_DOKUMENTE_FEHLER: {
            const a = <GetVeranstaltungDokumenteFehlerAction> action;

            return Object.assign({}, state, <PageState> {
                uiZeigeVeranstaltungDokumenteLaden: false,
                uiZeigeVeranstaltungDokumenteLadefehler: true,
                anzahlSpieltagDokumente: 0,
                anzahlAllgemeineDokumente: 0
            });
        }

        case TOGGEL_DOKUMENTE_GROUP_ACTION: {
            const a = <ToggleDokumenteGroupAction>action;

            let res = [...state.activeDokumenteGroups];
            if (res.includes(a.dokumenteGroupKey)) {
                res = res.filter((x) => x !== a.dokumenteGroupKey);
            } else {
                res.push(a.dokumenteGroupKey);
            }

            return Object.assign({}, state, {activeDokumenteGroups: res});
        }

        // SUCHE
        case actionsUi.DOKUMENT_SUCHEN: {
            const a = <actionsUi.DokumentSuchenAction> action;

            return Object.assign({}, state, <PageState> {
                filterString: a.filterString
            });
        }

        default: {
            return state;
        }
    }
}


/**
 * The createFeatureSelector function selects a piece of state from the root of the state object.
 * This is used for selecting feature states that are loaded eagerly or lazily.
 */
export const getModuleState = createFeatureSelector<ModuleState>('DokumentePage');

export const getPageState = createSelector(getModuleState, (state: ModuleState) => state.page);

// DATA
export const getDokumente = createSelector(getPageState, (state: PageState) => {
    if (state.dokumente !== null && state.dokumente !== undefined && state.dokumente.length > 0) {
        const filteredDocuments = state.dokumente.filter(item => state.filterString === '' || item.titel.toLowerCase().indexOf(state.filterString.toLowerCase()) !== -1);

        return [...filteredDocuments];
    }
    return state.dokumente;
});

export const getUiZeigeVeranstaltungDokumenteLaden = createSelector(getPageState, (state: PageState) => state.uiZeigeVeranstaltungDokumenteLaden);
export const getUiZeigeVeranstaltungDokumenteLadefehler = createSelector(getPageState, (state: PageState) => state.uiZeigeVeranstaltungDokumenteLadefehler);
export const getAnzahlSpieltagDokumente = createSelector(getPageState, (state: PageState) => state.anzahlSpieltagDokumente);
export const getAnzahlAllgemeineDokumente = createSelector(getPageState, (state: PageState) => state.anzahlAllgemeineDokumente);
export const getActiveDokumenteGroups = createSelector(getPageState, (state: PageState) => state.activeDokumenteGroups);


export const getSpieltagsDokumente = createSelector(getDokumente, getActiveDokumenteGroups, (pagedResultsDokument: Dokument[], activeDokumenteGroups: Array<string>) => {
    const property = 'gruppierung';
    if (!pagedResultsDokument) {
        return [];
    }

    const dokumente = pagedResultsDokument.filter(x => {
        return x.ist_allgemeines_dokument === false;
    }).map(item => {
        console.log(item.gruppierung);
        if (item.gruppierung === undefined || item.gruppierung === null || item.gruppierung === '') {
            return Object.assign({}, item, {gruppierung: '....'});
        }
        return item;
    });

    const groupedDokumente = dokumente.reduce((previous, current) => {
        if (!previous[current[property]]) {
            previous[current[property]] = [current];
        } else {
            previous[current[property]].push(current);
        }

        return previous;
    }, {});
    // this will return an array of objects, each object containing a group of objects
    const res = Object.keys(groupedDokumente).map(key => ({ key, value: groupedDokumente[key], open: activeDokumenteGroups.includes(key) }));
    return res.sort((a, b) => a.key.localeCompare(b.key, undefined, { caseFirst: 'upper' }));
});

export const getAllgemeineDokumente = createSelector(getDokumente, getActiveDokumenteGroups, (pagedResultsDokument: Dokument[], activeDokumenteGroups: Array<string>) => {
    const property = 'gruppierung';
    if (!pagedResultsDokument) {
        return [];
    }

    const dokumente = pagedResultsDokument.filter(x => x.ist_allgemeines_dokument === true).map(item => {
        if (item.gruppierung === undefined || item.gruppierung === null || item.gruppierung === '') {
            return Object.assign({}, item, {gruppierung: '....'});
        }
        return item;
    });

    const groupedDokumente = dokumente.reduce((previous, current) => {
        if (!previous[current[property]]) {
            previous[current[property]] = [current];
        } else {
            previous[current[property]].push(current);
        }

        return previous;
    }, {});

    // this will return an array of objects, each object containing a group of objects
    const res = Object.keys(groupedDokumente).map(key => ({ key, value: groupedDokumente[key], open: activeDokumenteGroups.includes(key) }));
    return res.sort((a, b) => a.key.localeCompare(b.key, undefined, { caseFirst: 'upper' }));
});
